/*
 * Paginarea, dupa forma din contract: `{items, total, page, per_page}`.
 *
 * Se citesc valorile din raspuns, nu cele cerute: contractul taie `per_page`
 * peste 100 fara eroare, deci numarul de pagini calculat cu valoarea ceruta ar
 * fi gresit exact acolo unde conteaza - la liste lungi.
 */

import { plural } from '../lib/format';
import { t } from '../lib/i18n';

export function Pager({
  total,
  page,
  perPage,
  unit = ['item', 'items'],
  onPage,
}: {
  total: number;
  page: number;
  perPage: number;
  unit?: [string, string];
  onPage: (page: number) => void;
}) {
  const pages = Math.max(1, Math.ceil(total / Math.max(1, perPage)));
  if (pages <= 1) return null;

  const go = (next: number) => {
    onPage(next);
    /* Pagina noua incepe de sus: altfel omul apasa "Next" si vede mijlocul
       listei urmatoare, fara sa-si dea seama ca s-a schimbat ceva. */
    window.scrollTo({ top: 0, behavior: 'auto' });
  };

  return (
    <nav className="pager" aria-label={t('Pagination')}>
      <button type="button" className="btn btn--sm" disabled={page <= 1} onClick={() => go(page - 1)}>{t('Previous')}</button>
      {/*
        * Prin `t()`, ca restul ecranului.
        *
        * "Page" si "of" erau scrise direct in markup, desi cheile lor existau
        * de mult in dictionar - iar unitatea vine ca text englezesc de la
        * apelant si pleca netradusa. Pe o pagina romaneasca scria
        * "Page 1 of 3 · 12 services", si nimeni n-a observat fiindca era in
        * subsolul listei.
        */}
      <span className="pager__status">
        {t('Page')} {page} {t('of')} {pages}
        <span className="pager__total">
          {total} {t(plural(total, unit[0], unit[1]))}
        </span>
      </span>
      <button
        type="button"
        className="btn btn--sm"
        disabled={page >= pages}
        onClick={() => go(page + 1)}
      >{t('Next')}</button>
    </nav>
  );
}
